module.exports = __webpack_public_path__ + "img/unproductive-apps-urls-reports.1a1a9d13.png";